import Icon from '../components/Icon.vue'

Icon.register({
  'frown-open': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM136 208c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zM323.3 391.3c11.4 3.5 22.5-6.2 20.5-18.1-7-39.9-60.1-61.2-95.8-61.2s-88.8 21.2-95.8 61.2c-2 11.8 9 21.6 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3zM328 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})
